import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import QuoteForm from '../../components/feature/QuoteForm';

export default function Home() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      text: "Our cracked driveway looked terrible. This team resurfaced it in two days—now it's smooth as glass. Best asphalt contractor in Lincoln, hands down!",
      author: "Sarah M., Lincoln NE",
    },
    {
      text: "Professional service from start to finish. They repaired our parking lot potholes and sealed the entire surface. Looks brand new and the price was very fair.",
      author: "Mike T., Lincoln NE",
    },
    {
      text: "I needed emergency pothole repair for my business. They came out the same day and fixed it perfectly. Highly recommend for commercial asphalt work in Lincoln.",
      author: "Jennifer L., Lincoln NE",
    },
  ];

  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Licensed & Insured',
      description: 'Fully licensed, bonded, and insured for your peace of mind and protection.',
    },
    {
      icon: 'ri-award-line',
      title: '25+ Years Experience',
      description: 'Decades of expertise in asphalt and concrete paving throughout Lincoln, NE.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Free Estimates',
      description: 'No-obligation free quotes for all residential and commercial paving projects.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Local Family Owned',
      description: 'Proud Lincoln business serving our community with integrity and quality.',
    },
  ];

  const process = [
    {
      number: '1',
      title: 'Free Consultation',
      description: 'Contact us for a free on-site evaluation and detailed project estimate.',
    },
    {
      number: '2',
      title: 'Custom Proposal',
      description: 'Receive a comprehensive quote with timeline, materials, and pricing.',
    },
    {
      number: '3',
      title: 'Professional Work',
      description: 'Our experienced crew completes your project with quality craftsmanship.',
    },
    {
      number: '4',
      title: 'Final Inspection',
      description: 'We ensure your complete satisfaction with a thorough quality check.',
    },
  ];

  const services = [
    {
      title: 'Asphalt Driveway Installation',
      category: 'RESIDENTIAL',
      description: 'Professional asphalt driveway installation with quality materials and expert craftsmanship for long-lasting results.',
      image: 'https://public.readdy.ai/ai/img_res/1ef8a699b3263e9a6fb9d8f11f5bb1c4.jpg',
      link: '/services/paving-estimate',
    },
    {
      title: 'Sealcoating & Resurfacing',
      category: 'MAINTENANCE',
      description: 'Protect and extend the life of your asphalt with professional sealcoating and resurfacing services.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/1d341b830006dccc92ac506855005153.jpeg',
      link: '/services/sealcoating',
    },
    {
      title: 'Concrete Driveway Work',
      category: 'RESIDENTIAL',
      description: 'Expert concrete driveway installation and repair services with durable materials and professional finishing.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/7f58e296e43dc268d8a68a74c122d5b3.jpeg',
      link: '/services/concrete-driveway',
    },
    {
      title: 'Pothole & Crack Repair',
      category: 'REPAIR',
      description: 'Fast and effective pothole and crack repair to restore your pavement and prevent further damage.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/1edf4356499a44df8027e59f95d91381.jpeg',
      link: '/services/pothole-repair',
    },
    {
      title: 'Commercial Parking Lots',
      category: 'COMMERCIAL',
      description: 'Large-scale commercial parking lot paving, striping, and maintenance for businesses in Lincoln.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/9af9c571bfa801216d00bad9424cff3f.jpeg',
      link: '/services/parking-lot',
    },
    {
      title: 'Asphalt Repair Services',
      category: 'REPAIR',
      description: 'Comprehensive asphalt repair and restoration services to fix damaged pavement and extend its lifespan.',
      image: 'https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/972a8b4f4b7e2a85975c7d84f53ecc6d.jpeg',
      link: '/services/asphalt-repair',
    },
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />

      {/* Hero Section - Mobile Optimized */}
      <header className="relative min-h-[100svh] flex items-center justify-center overflow-hidden pt-20">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://readdy.ai/api/search-image?query=epic%20industrial%20asphalt%20paving%20construction%20site%20with%20massive%20heavy%20machinery%20and%20powerful%20paving%20equipment%20laying%20fresh%20jet%20black%20asphalt%20dramatic%20low%20angle%20shot%20with%20gritty%20textures%20industrial%20atmosphere%20semi%20futuristic%20aesthetic%20with%20advanced%20technology%20steel%20and%20concrete%20structures%20moody%20dramatic%20lighting%20with%20strong%20shadows%20and%20highlights%20emphasizing%20raw%20power%20and%20scale%20of%20commercial%20paving%20operations%20creating%20dark%20dramatic%20background%20for%20high%20contrast%20white%20text&width=1920&height=1080&seq=101&orientation=landscape"
            alt="Professional asphalt paving services in Lincoln Nebraska"
            className="w-full h-full object-cover object-center"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black text-white mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Oswald, sans-serif' }}>
            <strong>Lincoln's Premier</strong><br />
            <strong>Asphalt & Concrete</strong><br />
            <strong>Paving Experts</strong>
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/95 mb-6 sm:mb-8 max-w-3xl mx-auto font-medium px-4">
            Professional <strong>asphalt paving</strong>, <strong>concrete driveways</strong>, <strong>sealcoating</strong>, and <strong>repair services</strong> in Lincoln, NE. Quality workmanship, competitive pricing, free estimates.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-stretch sm:items-center px-4">
            <a href="tel:3084705637" className="bg-primary-600 text-white px-8 sm:px-10 py-4 sm:py-5 rounded-lg text-base sm:text-lg font-bold hover:bg-primary-700 transition-all shadow-2xl whitespace-nowrap cursor-pointer text-center min-h-[56px] flex items-center justify-center">
              CALL (308) 470-5637
            </a>
            <Link to="/contact" className="bg-white text-gray-900 px-8 sm:px-10 py-4 sm:py-5 rounded-lg text-base sm:text-lg font-bold hover:bg-gray-100 transition-all shadow-2xl whitespace-nowrap cursor-pointer text-center min-h-[56px] flex items-center justify-center">
              GET FREE QUOTE
            </Link>
          </div>
        </div>
      </header>

      {/* Services Section - Mobile Optimized */}
      <section className="py-12 sm:py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-gray-900 mb-3 sm:mb-4 px-4" style={{ fontFamily: 'Oswald, sans-serif' }}>
              <strong>Our Paving Services in Lincoln, NE</strong>
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Comprehensive <strong>asphalt and concrete solutions</strong> for residential and commercial properties throughout Lincoln, Nebraska
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {services.map((service, index) => (
              <article key={index} className="bg-white rounded-xl sm:rounded-2xl shadow-lg hover:shadow-2xl transition-all overflow-hidden border border-gray-100 cursor-pointer">
                <div className="w-full h-48 sm:h-56 lg:h-64">
                  <img
                    src={service.image}
                    alt={`${service.title} services in Lincoln NE`}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="p-5 sm:p-6 lg:p-8">
                  <span className="inline-block bg-primary-100 text-primary-700 px-3 sm:px-4 py-1 rounded-full text-xs sm:text-sm font-semibold mb-3 sm:mb-4">
                    {service.category}
                  </span>
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3">
                    <strong>{service.title}</strong>
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  <Link
                    to={service.link}
                    className="inline-flex items-center text-primary-600 font-bold hover:text-primary-700 transition-colors cursor-pointer text-sm sm:text-base min-h-[44px]"
                    aria-label={`Learn more about ${service.title}`}
                  >
                    Learn More <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section - Mobile Optimized */}
      <section className="py-12 sm:py-16 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-gray-900 mb-3 sm:mb-4 px-4" style={{ fontFamily: 'Oswald, sans-serif' }}>
              <strong>Why Choose Lincoln Asphalt & Concrete?</strong>
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Your trusted <strong>local paving contractor</strong> with decades of experience serving Lincoln, Nebraska
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
            {features.map((feature, index) => (
              <article key={index} className="bg-white p-6 sm:p-8 rounded-xl sm:rounded-2xl shadow-lg text-center hover:shadow-xl transition-all">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                  <i className={`${feature.icon} text-2xl sm:text-3xl text-primary-600`}></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                  <strong>{feature.title}</strong>
                </h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{feature.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section - Mobile Optimized */}
      <section className="py-12 sm:py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-gray-900 mb-3 sm:mb-4 px-4" style={{ fontFamily: 'Oswald, sans-serif' }}>
              <strong>Our Proven Paving Process</strong>
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Simple, transparent steps from <strong>free estimate</strong> to project completion
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
            {process.map((step, index) => (
              <article key={index} className="relative">
                <div className="bg-white p-6 sm:p-8 rounded-xl sm:rounded-2xl shadow-lg text-center hover:shadow-xl transition-all h-full">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 bg-primary-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 text-xl sm:text-2xl font-bold">
                    {step.number}
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                    <strong>{step.title}</strong>
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{step.description}</p>
                </div>
                {index < process.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <i className="ri-arrow-right-line text-3xl text-primary-600"></i>
                  </div>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section - Mobile Optimized */}
      <section className="py-12 sm:py-16 lg:py-24 bg-gradient-to-br from-primary-600 to-primary-700">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4 sm:mb-6 px-4" style={{ fontFamily: 'Oswald, sans-serif' }}>
            <strong>Ready to Start Your Paving Project?</strong>
          </h2>
          <p className="text-lg sm:text-xl lg:text-2xl text-white/95 mb-6 sm:mb-10 font-medium px-4">
            Get your <strong>free estimate</strong> today! Serving Lincoln, NE and surrounding areas.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-stretch sm:items-center px-4">
            <a href="tel:3084705637" className="bg-white text-primary-600 px-8 sm:px-12 py-4 sm:py-6 rounded-lg text-lg sm:text-xl font-bold hover:bg-gray-100 transition-all shadow-2xl whitespace-nowrap cursor-pointer text-center min-h-[56px] flex items-center justify-center">
              CALL (308) 470-5637
            </a>
            <Link to="/contact" className="bg-gray-900 text-white px-8 sm:px-12 py-4 sm:py-6 rounded-lg text-lg sm:text-xl font-bold hover:bg-gray-800 transition-all shadow-2xl whitespace-nowrap cursor-pointer text-center min-h-[56px] flex items-center justify-center">
              REQUEST FREE QUOTE
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
